import {Button, ButtonProps, useStyleConfig, useMediaQuery} from '@chakra-ui/react';
import React, {memo} from 'react';
import {RiCheckboxCircleFill} from 'react-icons/all';
import {spacing} from '~/utils/theme/spacing';
import {UiBox, UiIcon, UiImage, UiText} from '.';
import {Option} from '~/redux/questionnaires/types';

interface Props {
  selected: boolean;
  onClick: () => void;
  value: Option;
  labelFontSize?: number;
}

export const UiToggleButton = memo(({selected, onClick, value, labelFontSize, ...rest}: Props) => {
  return (
    <UiBox key={`${value.label}-${value.value}`} onClick={onClick} {...rest}>
      <UiBox display="flex" justifyContent="center">
        <UiBox
          display="flex"
          justifyContent="center"
          alignItems="center"
          w="64px"
          h="64px"
          borderWidth={2}
          borderColor={selected ? 'fadedJade' : 'borderColor'}
          borderRadius="100%"
          backgroundColor="white"
          position="relative"
        >
          {selected && (
            <UiIcon
              as={RiCheckboxCircleFill}
              color="fadedJade"
              position="absolute"
              top={0}
              right={0}
              m={0}
              backgroundColor="white"
              borderRadius="100%"
            />
          )}
          <UiImage type="icon" name={value.icon} w="32px" h="32px" />
        </UiBox>
      </UiBox>
      <UiText mt={spacing.tiny} fontWeight={500} fontSize={labelFontSize}>
        {value.label}
      </UiText>
    </UiBox>
  );
});
